<template>
  <div>
    <div
      v-for="i in range"
      :key="'empty-box_' + i"
      class="box py-4 mb-1 position-relative"
      :data-test-id="'empty-widget__disabled_' + i"
    >
      <div class="mask disabled rounded" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  range?: number
}>(), {
  range: 5
})
</script>
